var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHybridHitlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 104,
    viewBox: "0 0 115 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3157 46.5263L33.1578 49.0526V56.6316L48.3157 54.1053V46.5263ZM48.3157 46.5263V23.1579M78.6315 18.7368V11.1579L48.3157 14.9474V23.1579M78.6315 18.7368L48.3157 23.1579M78.6315 18.7368V42.7368M78.6315 42.7368L63.4736 45.2632V52.8421L78.6315 50.3158V42.7368Z",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 65.1579H112.526M41.4737 102C46.2412 95.9802 49.0021 88.6176 49.3684 80.9474M73.0526 102C68.2851 95.9802 65.5242 88.6176 65.1579 80.9474M33.5789 102H80.9474M112.526 49.3684V75.6842C112.526 77.0801 111.972 78.4188 110.985 79.4058C109.998 80.3929 108.659 80.9474 107.263 80.9474H7.26316C5.86728 80.9474 4.52858 80.3929 3.54154 79.4058C2.55451 78.4188 2 77.0801 2 75.6842V7.26316C2 5.86728 2.55451 4.52858 3.54154 3.54155C4.52858 2.55451 5.86728 2 7.26316 2H49.3684C49.3684 2 103.542 2 107.263 2C110.985 2 112.526 3.54155 112.526 7.26316C112.526 10.9848 112.526 49.3684 112.526 49.3684Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybridHitlist);
export default __webpack_public_path__ + "static/media/hybridHitlist.91c0b036124b566205c9385d3acaacb6.svg";
export { ForwardRef as ReactComponent };